import { render } from "./userInfo.vue?vue&type=template&id=0b08c6f8&scoped=true"
import script from "./userInfo.vue?vue&type=script&lang=js"
export * from "./userInfo.vue?vue&type=script&lang=js"

import "./userInfo.vue?vue&type=style&index=0&id=0b08c6f8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0b08c6f8"

export default script